import { apiGetBlob, apiGetJSON } from "../../client.js";
import { normalizeThreadDiagnostics } from "../../domain/diagnostics.js";

export async function enrichLLMThreadSnapshot(apiKey, snapshot, threadID, options = {}) {
  const signal = options.signal || null;
  await hydrateRenderableAttachments(apiKey, snapshot, signal);
  if (options.includeDiagnostics === false) {
    return {
      ...snapshot,
      threadDiagnostics: null,
      workspaceDiagnostics: null
    };
  }
  const threadDiagnostics = await apiGetJSON(apiKey, `/v1/threads/${encodeURIComponent(threadID)}/diagnostics`, { signal });
  return {
    ...snapshot,
    threadDiagnostics: normalizeThreadDiagnostics(threadDiagnostics),
    workspaceDiagnostics: null
  };
}

async function hydrateRenderableAttachments(apiKey, snapshot, signal) {
  const attachments = collectRenderableAttachments(snapshot);
  const cache = new Map();
  await Promise.all(attachments.map(async (attachment) => {
    const id = String(attachment?.id || "").trim();
    const mediaKind = String(attachment?.media_kind || "").trim();
    if (!id || cache.has(id) || !attachment.content_url || (mediaKind !== "image" && mediaKind !== "audio")) {
      return;
    }
    const { blob } = await apiGetBlob(apiKey, attachment.content_url, { signal });
    cache.set(id, URL.createObjectURL(blob));
  }));
  for (const attachment of attachments) {
    const id = String(attachment?.id || "").trim();
    if (id && cache.has(id)) {
      attachment.object_url = cache.get(id);
    }
  }
}

function collectRenderableAttachments(snapshot) {
  const attachments = [];
  for (const ref of snapshot?.thread?.pinned_context_refs || []) {
    if (ref?.attachment) {
      attachments.push(ref.attachment);
    }
  }
  for (const turn of snapshot?.turns || []) {
    for (const part of turn?.input_parts || []) {
      if (part?.attachment) {
        attachments.push(part.attachment);
      }
    }
    for (const part of turn?.output_parts || []) {
      if (part?.attachment) {
        attachments.push(part.attachment);
      }
    }
  }
  return attachments;
}
